export enum EOptionMenuItemCallback {
  None = 'NONE',
  Delete = 'DELETE',
  Edit = 'EDIT',
  Replace = 'REPLACE',
  Preview = 'PREVIEW',
  Settings = 'SETTINGS',
  Move = 'MOVE',
  MoveToTop = 'MOVE TO TOP',
  MoveUp = 'MOVE UP',
  MoveDown = 'MOVE DOWN',
  MoveToBottom = 'MOVE TO BOTTOM',
}
